import React from 'react';

const SmileIcon = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style: { ...style, overflow: "visible" }
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.08333 7.5V8.33333M12.9167 7.5V8.33333M12.9167 12.24C12.9167 12.24 11.8225 13.3333 10 13.3333C8.17667 13.3333 7.08333 12.24 7.08333 12.24M2.5 10C2.5 5.8575 5.8575 2.5 10 2.5C14.1425 2.5 17.5 5.8575 17.5 10C17.5 14.1425 14.1425 17.5 10 17.5C5.8575 17.5 2.5 14.1425 2.5 10Z",
      stroke: "white",
      strokeOpacity: "0.6",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
SmileIcon.displayName = "Icons.SmileIcon";

export { SmileIcon };
//# sourceMappingURL=SmileIcon.js.map
